<!-- <div class="owl-game" *ngIf="data">
    <div class="owl-item row">
        <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let item of data.event_types;trackBy:trackByIndex;">
            <a class="item items" href="javascript:void(0)" (click)="openModal(template, item)">
                <div class="d-inline-block casinoicons">
                    <img alt="Game Shows Lobby" src="https://cdn.hub88.io/evolution/evo_gameshowslobby.jpg" />
                    <span>{{item.name}}</span>
                </div>
            </a>
        </div>
    </div>
</div> -->

<div class="row py-2 mx-0 home_casinos_thumb" *ngIf="data">
    <div class="col-md-2 col-6 align-self-center text-center csn-col"
        *ngFor="let item of data.event_types;trackBy:trackByIndex;">
        <div class="casino position-relative"  (click)="openModal(template, item)">
            <!-- <span>{{item.name}}</span> -->
            <img class="img-fluid" src="https://speedcdn.io/assets/casinogames-new-v1/{{item?.id}}.webp">
            <!-- <a href="javascript:void(0);" class="btn casino-btn">{{item.name}}</a> -->
        </div>
    </div>
</div>
<app-loader class="no-overlay" *ngIf="!data"></app-loader>

<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title pull-left">{{gameName}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <iframe scrolling="no" [src]="iframeUrl" allowfullscreen="true" title="game" id="casino-link"></iframe>
        </div>
    </div>
</ng-template>